'use client';

import { useRouter } from 'next/navigation';
import { useState } from 'react';
import InputField from '@src/components/atoms/textfield/inputField';
import SearchIcon from '@src/components/icons/search';

/**
 * Search for the governance corpus, above the filters on every list page.
 *
 * Above them, and not inside their row, because it does not narrow the current
 * slice — the search endpoint queries everything and cannot be scoped to a
 * hub, so submitting leaves whatever filter is applied and searches the whole
 * corpus. Placing it in the filter row implied the opposite.
 *
 * Submits on Enter rather than as you type: it navigates, and a navigation per
 * keystroke is not something to do on someone's behalf.
 */
export default function SearchBox({
  defaultValue = '',
  placeholder = 'Search Governance Actions...',
}: {
  defaultValue?: string;
  placeholder?: string;
}) {
  const router = useRouter();
  const [term, setTerm] = useState(defaultValue);

  const submit = () => {
    const query = term.trim();
    router.push(
      query
        ? `/governance_actions?q=${encodeURIComponent(query)}`
        : '/governance_actions'
    );
  };

  return (
    <InputField
      inputfieldSize="small"
      placeholder={placeholder}
      value={term}
      onChange={(event) => setTerm(event.target.value)}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          submit();
        }
      }}
      preActions={[
        <SearchIcon
          key="searchIcon"
          className="cursor-pointer text-dark-neutral-900 dark:text-white"
          onClick={submit}
        />,
      ]}
      className="w-full"
    />
  );
}
